import React, { useState } from "react";
import {
  IconButton,
  Input,
  Paper,
  SvgIcon,
  Tooltip,
} from "@mui/material";
import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Send as SendIcon } from "react-feather";

const useStyles = makeStyles((theme: any) => ({
  root: {
    alignItems: "center",
    backgroundColor: theme.palette.background.dark,
    display: "flex",
    padding: theme.spacing(1.7, 2),
  },
  inputContainer: {
    flexGrow: 1,
    marginLeft: theme.spacing(2),
    padding: theme.spacing(1),
  },
  divider: {
    height: 24,
    width: 1,
  },
  fileInput: {
    display: "none",
  },
  search: {
    display: "flex",
    alignItems: "center",
    height: 44,
    borderRadius: 12,
    width: theme.spacing(300),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    backgroundColor: theme.palette.primary.light,
  },
  searchInput: {
    flexGrow: 1,
    marginLeft: theme.spacing(1),

  },
}));

const MessageComposer = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [body, setBody] = useState("");

  const handleChange = (event) => {
    event.persist();
    setBody(event.target.value);
  };

  const handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      handleSend();
    }
  };

  const handleSend = async () => {
    if (!body) {
      return;
    }
    await props.send(body).then(setBody(""));
  };

  return (
    <div className={classes.root} style={{ marginBottom: theme.spacing(-3.5) }}>
      <div className={classes.search}>
        <Input
          disableUnderline
          fullWidth
          value={body}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          placeholder="Send a message..."
          disabled={props.disabled}
          className={classes.searchInput}
        />
      </div>
      <Tooltip
        title="Send Message"
        style={{
          marginLeft: theme.spacing(1)
        }}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: "#46464f",
              color: "white"
            }
          }
        }}
      >
        <span>
          <IconButton
            color="secondary"
            disabled={!body || props.disabled}
            onClick={handleSend}
          >
            <SvgIcon fontSize="small">
              <SendIcon />
            </SvgIcon>
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
};

MessageComposer.defaultProps = {
  disabled: false,
  onSend: () => { },
};

export default MessageComposer;
